var domainUrl = document.getElementById("site-url").innerText;
window.onload = function() {
    domainUrl = document.getElementById("site-url").innerText;
    if (window.jQuery) {
        console.log("jquery present");
    } else {
            console.log("adding jquery");
            var jquery_script = document.createElement("script"); 
            jquery_script.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js";  
            document.getElementsByTagName('head')[0].appendChild(jquery_script);        
    }
    var shopify_script = document.createElement("script"); 
    shopify_script.src = "https://cdn.shopify.com/s/shopify/api.jquery.js";
    document.getElementsByTagName('head')[0].appendChild(shopify_script);

}
// Setting count for add all to cart products
var addToCartCount;
var product_sections;

// ADD ALL TO CART LINK
var addMainProductsToCartLink;
var addBundleProductsToCartLink;
var addUpsellProductsToCartLink;

var active_products_count = 0;
var active_main_products_count = 0;
var active_bundle_products_count = 0;
var active_upsell_products_count = 0;

var url_string = window.location.href;
var url = new URL(url_string);
var products;
let selected_pdt;
var imgid = url.searchParams.get("id");
var resp_id = url.searchParams.get("resp_id");

var language_isocode = document.getElementById("site-iso-code").innerText;
var default_addToCartText = "Add to cart";
var default_addedToCartText = "Added to Cart!";
let outOfStock = "Out of Stock";
var domainCurrency;

// Default url path for product
var variant_product_url;

var product_options_map = {};

var option1array = [];
var option2array = [];
var option3array = [];

var variantOption1_div;
var variantOption2_div;
var variantOption3_div;

// Options name mapped to variant id
var option2_variant_map = {};

const el = (sel, par) => (par||document).querySelector(sel);        
const elPopup = el("#tangent-popup-msg");      
const elPopupCondtion = el("#tangent-popup-msg-condition");
var skip_selfie=false;
// Array of conditions detected on selfie with message to be shown onclick
var condition_msg_map =[];

// Consolidated final regions with products found
var final_selected_regions=[];

// Mapping possible tags from response to their possible regions
var area_mapping = {
  forehead:["rosacea_forehead","dark_spots_forehead","wrinkles_forehead","acne_forehead"],
  left_cheek:["rosacea_left_cheek","dark_spots_left_cheek","acne_left_cheek"],
  right_cheek:["rosacea_right_cheek","dark_spots_right_cheek","acne_right_cheek"],
  left_eye:["rosacea_left_eye","dark_spots_left_eye","acne_left_eye"],
  right_eye:["rosacea_right_eye","dark_spots_right_eye","acne_right_eye"],
  left_jaw:["dark_spots_left_jaw","acne_left_jaw"],
  right_jaw:["dark_spots_right_jaw","acne_right_jaw"],
  chin:["dark_spots_chin","acne_chin"],
  nose:["rosacea_nose","dark_spots_nose","acne_nose"],
  right_eye_under:["wrinkles_right_eye_under","dark_circles_right_eye_under"],
  right_eye_corner:["wrinkles_right_eye_corner"],
  left_eye_under:["wrinkles_left_eye_under","dark_circles_left_eye_under"],
  left_eye_corner:["wrinkles_left_eye_corner"],
  right_lip_corner:["wrinkles_right_lip_corner"],
  left_lip_corner:["wrinkles_left_lip_corner"]
};

var all_tags;

const currentScriptUrl = document.currentScript.src;
const tangentAssetsBase = 'https://a.tangent.ai/DND/face-mapping/';

if (resp_id != null) {

    // Enable loader when response id is present
    toggle_loader_view(true);
  
    changeLoadingText("Fetching your results...");
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id=" + resp_id + "&self_serve=true" + "&multiple_variants=true";
    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
            if (xmlhttp.status == 200) {
                var jsonData = JSON.parse(xmlhttp.responseText);
                // document.getElementById('tangent-selfie-container-div').innerHTML = jsonData.selfie_html;
                products = jsonData.products;
                domainCurrency = document.getElementById("site-currency").innerText; 
                changeLoadingText("Scanning your selfie...");
                  
                all_tags = jsonData.tags;

                product_sections = jsonData.product_sections;
              
                if(product_sections!=undefined){
                  createProductSection(jsonData);
                }
                
                if(jsonData.text_sections!=undefined){
                  createTextSection(jsonData);
                }
                
                addMainProductsToCartLink = domainUrl + "/cart/add?id[]=";
                addBundleProductsToCartLink = domainUrl + "/cart/add?id[]=";
                addUpsellProductsToCartLink = domainUrl + "/cart/add?id[]=";
                addProductsToCartLink = domainUrl + "/cart/add?id[]=";
                
                // Default image hiding
                document.getElementById('selfie_img_cover').style.display = "none";
                document.getElementById('tangent_selfie_div').style.display = "flex";
                document.getElementById('selfie_img').src = jsonData.selfie_url;
                if(jsonData.selfie_html!=null && jsonData.selfie_html!=undefined){
                  // document.getElementById("default-image").style.display="none";
                  // document.getElementById('selfie_img').src = jsonData.selfie_url;
                  // document.getElementById('tangent-selfie-container-div').innerHTML = jsonData.selfie_html;
                }
                else{
                  // document.getElementById("default-image").style.display="flex";
                  document.getElementById("tangent-img-container-parent").style.display="none";
                  document.getElementById("selfie_img").style.display="none";
                  document.getElementById("selfie_canvas").style.display="none";
                  skip_selfie= true;
                }

                // Add face markings based on tags
                addMarkings()
                
                if (products.length > 0) {

                    selected_pdt = {};
                    active_product_count = 0;
                    var select_variant_obj;
                    for (var p = 0; p < products.length; p++) {
                        select_variant_obj = products[p].variants[0];
                        option1array = [];
                        option2array = [];
                        option3array = [];
                        variant_product_url = domainUrl + '/products/';
                        var variant_price;

                        var imgsrc = "";
                        if (domainCurrency == "") {
                            domainCurrency = '$';
                        }
                        if (products[p].images != undefined) {
                            imgsrc = getVariantImage(products[p].variants[0].image_id,products[p]);
                        }
                        else{
                            imgsrc = "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp";
                        }

                        variantOption1_div = document.createElement("div");
                        variantOption1_div.classList.add("tangent_option_div");

                        variantOption2_div = document.createElement("div");
                        variantOption2_div.classList.add("tangent_option_div");

                        variantOption3_div = document.createElement("div");
                        variantOption3_div.classList.add("tangent_option_div");

                        var variant_checkbox_elm = document.getElementById('tangent_variant_view_check');

                        variant_price = products[p].variants[0].price;
                        variant_product_url = variant_product_url + products[p].handle + "?variant=" + products[p].variants[0].id;

                        let selectedVariant = isSelectedVariantPresent(jsonData.selected_variants, products[p].id)

                        // CHECK FOR VARIANT ENABLED
                        if (!selectedVariant.length && products[p].variants.length > 1) {
                            if (variant_checkbox_elm != undefined && variant_checkbox_elm != null) {
                                if (variant_checkbox_elm.value==true || variant_checkbox_elm.value=="true") {

                                    var variants_div = document.createElement("div");
                                    variants_div.id = 'tangent_checkout_variants_div_' + p;
                                    variants_div.classList.add("tangent_checkout_variants_div");
                                    variants_div.style.display = "none";

                                    var variantsub_div = document.createElement("div");
                                    variants_div.appendChild(variantsub_div);
                                    var _variants = products[p].variants;
                                    var option1_ele_arr = [];
                                    var option2_ele_arr = [];
                                    var option3_ele_arr = [];

                                    var option_obj = {};

                                    variants_div.style.display = "block";

                                    // Product Option 1 Name Element
                                    var option1_name = document.createElement("p");
                                    option1_name.id = "optionName_variant:product_" + p;
                                    option1_name.innerText = products[p].options[0].name + ":";
                                    option1_name.classList.add("tangent_option_name");
                                    variantOption1_div.append(option1_name);

                                    // Creating values for product option 1 
                                    var option1_values = products[p].options[0].values;
                                    for (var opt1v = 0; opt1v < option1_values.length; opt1v++) {
                                        var variants_option1 = document.createElement("p");
                                        variants_option1.id = "product_" + p + ":option_" + opt1v;
                                        variants_option1.title = option1_values[opt1v];
                                        variants_option1.innerText = option1_values[opt1v];
                                        variants_option1.classList.add("tangent_option");
                                        variants_option1.classList.add("product_" + p + "v1");
                                        variants_option1.classList.add("tangent_options_1");

                                        if (!option1array.includes(option1_values[opt1v])) {
                                            option1array.push(option1_values[opt1v]);
                                            option1_ele_arr.push(variants_option1);
                                            variantOption1_div.appendChild(variants_option1);
                                        }
                                    }
                                    if (option1_ele_arr.length > 0) { option_obj["option1"] = option1_ele_arr; }

                                    // Product Option 2 Name Element
                                    if (products[p].options.length > 1) {
                                        var option2_name = document.createElement("p");
                                        option2_name.id = "optionName_variant:product_" + p;
                                        option2_name.innerText = products[p].options[1].name + ":";
                                        option2_name.classList.add("tangent_option_name");
                                        variantOption2_div.append(option2_name);
                                    }

                                    // Creating values for product option 2
                                    if (products[p].options[1] != undefined) {
                                        var option2_values = products[p].options[1].values;
                                        for (var opt2v = 0; opt2v < option2_values.length; opt2v++) {
                                            var variants_option2 = document.createElement("p");
                                            variants_option2.id = "product_" + p + ":option_" + opt2v;
                                            variants_option2.title = option2_values[opt2v];
                                            variants_option2.innerText = option2_values[opt2v];
                                            variants_option2.classList.add("tangent_option");
                                            variants_option2.classList.add("product_" + p + "v2");
                                            variants_option2.classList.add("tangent_options_2");

                                            if (!option2array.includes(option2_values[opt2v])) {
                                                option2array.push(option2_values[opt2v]);
                                                option2_ele_arr.push(variants_option2);
                                                variantOption2_div.appendChild(variants_option2);
                                            }
                                        }
                                    }
                                    if (option2_ele_arr.length) { option_obj["option2"] = option2_ele_arr; }

                                    // Product Option 3 Name Element
                                    if (products[p].options.length > 2) {
                                        var option3_name = document.createElement("p");
                                        option3_name.id = "optionName_variant:product_" + p;
                                        option3_name.innerText = products[p].options[2].name + ":";
                                        option3_name.classList.add("tangent_option_name");
                                        variantOption3_div.append(option3_name);
                                    }

                                    // Creating values for product option 3
                                    if (products[p].options[2] != undefined) {
                                        var option3_values = products[p].options[2].values;
                                        for (var opt3v = 0; opt3v < option3_values.length; opt3v++) {
                                            var variants_option3 = document.createElement("p");
                                            variants_option3.id = "product_" + p + ":option_" + opt3v;
                                            variants_option3.title = option3_values[opt3v];
                                            variants_option3.innerText = option3_values[opt3v];
                                            variants_option3.classList.add("tangent_option");
                                            variants_option3.classList.add("product_" + p + "v3");
                                            variants_option3.classList.add("tangent_options_3");

                                            if (!option3array.includes(option3_values[opt3v])) {
                                                option3array.push(option3_values[opt3v]);
                                                option3_ele_arr.push(variants_option3);
                                                variantOption3_div.appendChild(variants_option3);
                                            }
                                        }
                                    }
                                    if (option3_ele_arr.length > 0) { option_obj["option3"] = option3_ele_arr; }

                                    product_options_map[products[p].id] = option_obj;

                                    var option2_var = {};
                                    var selected_variant;

                                    // All options for the product
                                    var options1;
                                    var options2;
                                    var options3;

                                    for (var v = 0; v < _variants.length; v++) {

                                        var optVariant;
                                        if (_variants[v].option1 != null) {
                                            optVariant = _variants[v].option1
                                        }
                                        if (_variants[v].option2 != null) {
                                            optVariant = optVariant + "_" + _variants[v].option2
                                        }
                                        if (_variants[v].option3 != null) {
                                            optVariant = optVariant + "_" + _variants[v].option3
                                        }

                                        option2_var[optVariant] = _variants[v];
                                        option2_variant_map[products[p].id] = option2_var;
                                    }

                                    // When product has no variant previously selected
                                    // Default Select Option 1
                                    if (product_options_map[products[p].id].option1 != undefined) {
                                        if (product_options_map[products[p].id].option1.length > 0) {
                                            options1 = product_options_map[products[p].id].option1;
                                            options1[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    // Default Select Option 2
                                    if (product_options_map[products[p].id].option2 != undefined) {
                                        if (product_options_map[products[p].id].option2.length > 0) {
                                            options2 = product_options_map[products[p].id].option2;
                                            options2[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    // Default Select Option 3
                                    if (product_options_map[products[p].id].option3 != undefined) {
                                        if (product_options_map[products[p].id].option3.length > 0) {
                                            options3 = product_options_map[products[p].id].option3;
                                            options3[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    selected_pdt[products[p].id] = _variants[0].id + "";
                                    select_variant_obj = _variants[0];

                                    variant_price = _variants[0].price;
                                    variant_product_url = variant_product_url + products[p].handle + "?variant=" + _variants[0].id;

                                    variantsub_div.appendChild(variantOption1_div);
                                    variantsub_div.appendChild(variantOption2_div);
                                    variantsub_div.appendChild(variantOption3_div);

                                }
                            }
                        }
                        if (selected_pdt[products[p].id] == null) {
                            selected_pdt[products[p].id] = products[p].variants[0].id;
                        }
                        if (!selectedVariant.length && (products[p].variants.length > 1 || products[p].variants.length == 1)) {
                            var product_html;
                            if(domainUrl==undefined){
                                domainUrl = document.getElementById("site-url").innerText;
                            }
                            
                            var pdtPrice = products[p].variants[0].price;
                            var var_products = products[p].variants;
                            var var_images = products[p].images;
                            var p_id = products[p].id;
                            var added_pdt = false;

                            if(product_sections!=undefined){
                              for (const section in product_sections) {
                                if (product_sections[section].includes(String(products[p].id))) {
                                  var product_section_grid = document.getElementById(section+"_product_grid");
                                  addToCartID = var_products[0].id;
                                  var image_id = var_products[0].image_id;
                                  for(var im=0;im<var_images.length;im++){
                                    if(image_id==var_images[im].id){
                                      imgsrc = var_images[im].src;
                                    }
                                  }
                                  console.log("222");
                                  product_html = '<div><a id="url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="image_tangent_product_' + p + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p id="price_tangent_product_' + p + '" class="tangent_product_price_text">' + domainCurrency + pdtPrice + '</p></a><div id="tangent_product_' + p + '"></div><a class="tangent-product-add-btn-wrapper" id="cart_tangent_product_' + p + '" onclick="addToCart('+selected_pdt[products[p].id]+','+p+')" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="cart_tangent_product_' + p + '_text">' + default_addToCartText + '</p></a><div/>';
                                  product_section_grid.innerHTML = product_section_grid.innerHTML + product_html;
                                  
                                }                                
                              }
                            }
                          
                            if (!selectedVariant.length && products[p].variants.length > 1) {
                                if (variant_checkbox_elm != undefined && variant_checkbox_elm != null) {
                                    if (variant_checkbox_elm.value==true || variant_checkbox_elm.value=="true") {
                                        var variant_element = document.getElementById('tangent_product_' + p);
                                        variant_element.appendChild(variants_div);
                                    }
                                }
                            }
                            var cart_btn = document.getElementById("cart_tangent_product_" + p);
                            var cart_btn_text = document.getElementById("cart_tangent_product_" + p + "_text");
                            if(cart_btn!=undefined){
                              // Check if Product is active
                              if (products[p].status == "active") {
                                    cart_btn.classList.remove("disable-btn-wrapper");
                                    if(select_variant_obj.inventory_policy == "deny"){
                                        if(select_variant_obj.inventory_quantity<1){
                                          if(select_variant_obj.inventory_management!=null){
                                            cart_btn_text.innerHTML = outOfStock;
                                            cart_btn.classList.add("disable-btn-wrapper");
                                          }
                                          else{
                                            addToCartLink(products[p].id,selected_pdt[products[p].id]);
                                          }
                                        }
                                        else{
                                            addToCartLink(products[p].id,selected_pdt[products[p].id]);
                                        }
                                    }
                                    else{
                                      addToCartLink(products[p].id,selected_pdt[products[p].id]);
                                  }
                              }
                              else {
                                  cart_btn_text.innerHTML = outOfStock;
                                  cart_btn.classList.add("disable-btn-wrapper");
                              }
                            }
                        }
                        //displaying selected products
                        if (selectedVariant.length) {
                            for (let i = 0; i < selectedVariant.length; i++) {
                                products[p].variants.forEach((variant) => {
                                    if (selectedVariant[i] == variant.id) {
                                        let imgurl = getVariantImage(variant.image_id,products[p]);
                                        let product_url = domainUrl + "/products/" + products[p].handle + "?variant=" + variant.id;
                                        
                                        let addTocartClass; 
                                        let buttonText;

                                        if(variant.inventory_policy == "deny"){
                                            if(variant.inventory_quantity<1){
                                              if(variant.inventory_management!=null){
                                                addTocartClass = "disable-btn-wrapper";
                                                buttonText = outOfStock;
                                              }  
                                              else{
                                                buttonText = default_addToCartText;
                                                addToCartLink(products[p].id,variant.id);
                                              }
                                            }
                                            else{
                                                buttonText = default_addToCartText;
                                                addToCartLink(products[p].id,variant.id);
                                            }
                                        }
                                        else{
                                            buttonText = default_addToCartText;
                                            addToCartLink(products[p].id,variant.id);
                                        }

                                        var product_html;
                                        selected_pdt[products[p].id] = variant.id;
                                        variant_price = variant.price;

                                        var pdtPrice = variant_price;
                                        var var_products = products[p].variants;
                                        var var_images = products[p].images;
                                        var p_id = products[p].id;
                                        var added_pdt = false;
                                      
                                        if(product_sections!=undefined){
                                          for (const section in product_sections) {
                                            if (product_sections[section].includes(String(products[p].id))) {
                                              console.log("wirkding");
                                              var product_section_grid = document.getElementById(section+"_product_grid");
                                              product_html = '<div><a id="url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="image_tangent_product_' + p + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p id="price_tangent_product_' + p + '" class="tangent_product_price_text">' + domainCurrency + pdtPrice + '</p></a><div id="tangent_product_' + p + '"></div><a class="tangent-product-add-btn-wrapper" id="cart_tangent_product_' + p + '" onclick="addToCart('+selected_pdt[products[p].id]+','+p+')" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="cart_tangent_product_' + p + '_text">' + default_addToCartText + '</p></a><div/>';
                                              product_section_grid.innerHTML = product_section_grid.innerHTML + product_html;
                                            }                                
                                          }
                                        }
                                    }
                                })
                            }
                        }
                    }
                  
                    addToCartCount = active_product_count;
                    // ENABLE EVENT LISTENER FOR ALL OPTIONS
                    var all_options = document.getElementsByClassName('tangent_option');
                    for (var o = 0; o < all_options.length; o++) {
                        all_options[o].addEventListener(
                            'click',
                            function () { changePdtVariant(this); },
                            false
                        );
                    }
                }
                else {
                    document.getElementById('tangent-general-text').innerHTML = "No products found. Please retry!";
                    console.log("No products found Please retry");
                }

                // if (jsonData.description != '') {
                //     document.getElementById('tangent-checkout-description').style.display = "block";
                //     document.getElementById('tangent-checkout-description').innerHTML = jsonData.description;
                // }
                // else {

                //     document.getElementById('tangent-general-text').style.display = "block";
                //     console.log("No descripton found");
                // }
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", checkout_url, true);
    xmlhttp.send();

}

// Section Creation
function createProductSection(jsonDt){
  var pdt_sections = jsonDt.product_sections;
  var txt_sections = jsonDt.text_sections;
  for (const section_name in pdt_sections) {
    var section_layout = document.getElementById(section_name+"_container");
    var section_div = document.createElement("div");
    section_div.id = section_name;
    section_div.classList.add("section_product_container");
    section_div.classList.add(section_name+"_product_container");

    if(txt_sections.hasOwnProperty(section_name)){
      insertTextSection(section_name, txt_sections);
    }
    
    var product_grid_div = document.createElement("div");
    product_grid_div.id = section_name+"_product_grid";
    product_grid_div.classList.add("section_product_grid");
    product_grid_div.classList.add(section_name+"_product_grid");
    section_div.appendChild(product_grid_div);

    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";
    add_all_cart_link.innerHTML = "Add all to Cart";
    add_all_cart_link.addEventListener(
        'click',
        function () { addAllTocartFunction(section_name); },
        false
    );
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
    
    // section_div.appendChild(add_all_to_cart_p_tag);
    
    section_layout.appendChild(section_div);
  }
}

function addMarkings(){
  if(all_tags.length>0){
    // Selecting final marking regions from all tags
    for (var area in area_mapping) {
      var possible_tags = area_mapping[area];
      for(var pt=0;pt<possible_tags.length;pt++){
        if(all_tags.includes(possible_tags[pt])){
          final_selected_regions.push(possible_tags[pt]);
        }
      }
    }
    
    checkForProduct();
    
    if(condition_msg_map.length>0){
      selfie.init(tangentAssetsBase).then(() => {
        const u_list = getUniqueListBy(condition_msg_map, 'area');
        
        // Remove non marking locations from list
        var non_marking_list = ["left_eye","right_eye","left_jaw","right_jaw"];
        var i = 0;
        while (i < u_list.length) {
          if (non_marking_list.includes(u_list[i].area)) {
            u_list.splice(i, 1);
          } else {
            ++i;
          }
        }
        // MAX Count to 4
        if(u_list.length>4){
          u_list.length=4;
        }
        for(var cm=0;cm<u_list.length;cm++){
          selfie.markFacialArea(canvas, u_list[cm].area, u_list[cm].msg);
        }
         selfie.setAreaClickCallback(canvas, selfieAreaClicked, true);
         toggle_loader_view(false);
       
      }).catch((error) => {
        console.log("Error in loading model "+error);
        toggle_loader_view(false);
        show_selfie_popupmessage("Something went wrong, please check your internet connection!");
      });
    }
    else{
      if(!skip_selfie){
        var message = "Your selfie + skin is looking clear today! Here are the best products for your current skin-state. Feel like we missed something? Try taking your selfie again";
        show_selfie_popupmessage(message);
      }
      toggle_loader_view(false);
    }
  }
}

function addToCartLink(pid,vid){
  if(product_sections!=undefined){
    for (const section in product_sections) {
      if (product_sections[section].includes(String(pid))) {
        switch(section) {
          case "section_main_products":
            if (active_main_products_count == 0) {
                addMainProductsToCartLink += vid;
            } else {
                addMainProductsToCartLink += "&id[]=" + vid;
            }
            active_main_products_count++;
            break;
          case "section_bundle":
            if (active_bundle_products_count == 0) {
                addBundleProductsToCartLink += vid;
            } else {
                addBundleProductsToCartLink += "&id[]=" + vid;
            }
            active_bundle_products_count++;
            break;
          default:
            if (active_upsell_products_count == 0) {
                addBundleProductsToCartLink += vid;
            } else {
                addBundleProductsToCartLink += "&id[]=" + vid;
            }
            active_upsell_products_count++;
        }
      }                                
    }
    if(active_upsell_products_count>0){
      document.getElementById("section_upsell_container").style.display="block";
    }
    
    if(active_bundle_products_count>0){
      document.getElementById("section_bundle_container").style.display="block";
    }
  }
}

// Section Text Creation
function createTextSection(jsonDt){
  var text_sections = jsonDt.text_sections;
  var pdt_sections = jsonDt.product_sections;
  for (const section_name in text_sections) {
    if(!pdt_sections.hasOwnProperty(section_name)){
      var section_layout = document.getElementById(section_name+"_container");
      var section_div = document.createElement("div");
      section_div.id = section_name+"_text_container";
      section_div.classList.add("section_text_container");
      section_div.classList.add(section_name+"_text_container");
      section_div.innerHTML = text_sections[section_name].join(' ');
      section_layout.appendChild(section_div);
    }
  }
}

function insertTextSection(section_name,text_sections){
  var section_layout = document.getElementById(section_name+"_container");
    var section_div = document.createElement("div");
    section_div.id = section_name+"_text_container";
    section_div.classList.add("section_text_container");
    section_div.classList.add(section_name+"_text_container");
    section_div.innerHTML = text_sections[section_name].join(' ');
    section_layout.appendChild(section_div);
}

function addAllTocartFunction(section) {   
    if ( active_work_pm_count > 0) {      
        if(section=='section_main_products'){
            document.getElementById(section+"_add_all_cart_link").setAttribute("href", addMainProductsToCartLink);       
        }
        else if(section=='section_bundle'){
            document.getElementById(section+"_add_all_cart_link").setAttribute("href", addBundleProductsToCartLink);
        }
        else{
            document.getElementById(section+"_add_all_cart_link").setAttribute("href", addUpsellProductsToCartLink);
        }
    }
    else {
        var x = document.getElementById("message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function changePdtVariant(ele) {
    
    var cartUrl = domainUrl + "/cart/add?id[]=";
    var eleId = ele.id;
    var arr = eleId.split(":");

    var productNumberText = arr[0];
    var optionNumberText = arr[1];
    var pStart = productNumberText.lastIndexOf('_');
    var oStart = optionNumberText.lastIndexOf('_');

    // Product and Option Number
    var pNo = productNumberText.substring(pStart + 1);
    var oNo = optionNumberText.substring(oStart + 1);

    //Product ID
    var pId = parseInt(pNo);

    var element = document.getElementById("cart_tangent_product_"+pId+"_text");
    if(element!=undefined){
      element.classList.remove("added-to-cart-style");
    }
    // Product Details
    var pdt = products[pId];

    var variant_price = domainCurrency;

    // Product Variants
    var product_variants = pdt.variants;

    // Variant Option Values
    var opt1_value;
    var opt2_value;
    var opt3_value;

    // Getting current variant option selections
    if (product_variants.length > 0) {
        for (var pv = 0; pv < product_variants.length; pv++) {
            if (product_variants[pv].id == selected_pdt[pdt.id]) {
                prev_variant = product_variants[pv];
                opt1_value = product_variants[pv].option1;
                opt2_value = product_variants[pv].option2;
                opt3_value = product_variants[pv].option3;
            }
        }
    }

    var opt1_list;
    // Identify and Highlight new selection if it is on Option 1 list of Product
    if (ele.classList.contains("tangent_options_1")) {
        opt1_list = document.getElementsByClassName("product_" + pId + "v1");
        if (opt1_list.length > 0) {
            for (var op1 = 0; op1 < opt1_list.length; op1++) {
                if (op1 == oNo) {
                    opt1_list[op1].classList.add("tangent_selected-variant");
                    opt1_value = opt1_list[op1].innerHTML;
                }
                else {
                    opt1_list[op1].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var opt2_list;
    // Identify and Highlight new selection if it is on Option 2 list of Product
    if (ele.classList.contains("tangent_options_2")) {
        opt2_list = document.getElementsByClassName("product_" + pId + "v2");
        if (opt2_list.length > 0) {
            for (var op2 = 0; op2 < opt2_list.length; op2++) {
                if (op2 == oNo) {
                    opt2_list[op2].classList.add("tangent_selected-variant");
                    opt2_value = opt2_list[op2].innerHTML;
                }
                else {
                    opt2_list[op2].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var opt3_list;
    // Identify and Highlight new selection if it is on Option 3 list of Product
    if (ele.classList.contains("tangent_options_3")) {
        opt3_list = document.getElementsByClassName("product_" + pId + "v3");
        if (opt3_list.length > 0) {
            for (var op3 = 0; op3 < opt3_list.length; op3++) {
                if (op3 == oNo) {
                    opt3_list[op3].classList.add("tangent_selected-variant");
                    opt3_value = opt3_list[op3].innerHTML;
                }
                else {
                    opt3_list[op3].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var option_variant_key;
    // Joining the options found and matching with options to variant mapping to get variant id
    if (opt1_value != null) {
        option_variant_key = opt1_value;
    }
    if (opt2_value != null) {
        option_variant_key = option_variant_key + "_" + opt2_value;
    }
    if (opt3_value != null) {
        option_variant_key = option_variant_key + "_" + opt3_value;
    }

    // Fetching and setting new variant id to selected product-id in product-variant map object
    if (option2_variant_map[pdt.id] != undefined) {
        if (option2_variant_map[pdt.id][option_variant_key] != undefined) {
            selected_pdt[pdt.id] = option2_variant_map[pdt.id][option_variant_key].id + "";
        }
    }

    var add_current_pdt = true;
    var cart_btn = document.getElementById("cart_tangent_product_" + pId);
    var cart_btn_text = document.getElementById("cart_tangent_product_" + pId + "_text");

    // Check if product is active and if not disable add to cart button
    if (pdt.status == "active") {
        if(cart_btn!=undefined){
          cart_btn.classList.remove("disable-btn-wrapper");

          // Choose variant object from variant list in product object using variant id mapped to product id in product-variant mapping object
          var variant_select;
          if (product_variants.length > 0) {
              for (var pv = 0; pv < product_variants.length; pv++) {
                  if (product_variants[pv].id == selected_pdt[pdt.id]) {
                      variant_select = product_variants[pv];
                  }
              }
          }

          if (variant_select != undefined) {
            if(variant_select.inventory_policy == "deny"){
                if(variant_select.inventory_quantity<1){
                    if(variant_select.inventory_management!=null){
                        add_current_pdt = false;
                        cart_btn_text.innerHTML = outOfStock;
                        cart_btn.classList.add("disable-btn-wrapper");
                    }
                    else{
                        selected_pdt[pdt.id] = variant_select.id;
                        var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                        cart_btn.classList.remove("disable-btn-wrapper");
                        cart_btn_text.innerHTML = default_addToCartText;
                        
                        var clickfun = cart_btn.getAttribute("onClick");
                        var funName = clickfun.substring(0,clickfun.indexOf("("));   
                        cart_btn.setAttribute("onclick",funName+"("+selected_pdt[pdt.id]+","+pId+")");   
                    } 
                }
                else{
                    selected_pdt[pdt.id] = variant_select.id;
                    var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                    cart_btn.classList.remove("disable-btn-wrapper");
                    cart_btn_text.innerHTML = default_addToCartText;
                    
                    var clickfun = cart_btn.getAttribute("onClick");
                    var funName = clickfun.substring(0,clickfun.indexOf("("));   
                    cart_btn.setAttribute("onclick",funName+"("+selected_pdt[pdt.id]+","+pId+")");   
                }
            }
            else{
                selected_pdt[pdt.id] = variant_select.id;
                var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                cart_btn.classList.remove("disable-btn-wrapper");
                cart_btn_text.innerHTML = default_addToCartText;
                
                var clickfun = cart_btn.getAttribute("onClick");
                var funName = clickfun.substring(0,clickfun.indexOf("("));   
                cart_btn.setAttribute("onclick",funName+"("+selected_pdt[pdt.id]+","+pId+")");   
            }
          }
        }
    }
    else {
        add_current_pdt = false;
        cart_btn_text.innerHTML = outOfStock;
        cart_btn.classList.add("disable-btn-wrapper");
    }

    var sp = 0;
    // Loop through product list and update cart url for add all to cart
    for (var p = 0; p < products.length; p++) {
        var product_variants = products[p].variants;

        // Check if product status , if not skip adding to cart-url
        if (products[p].status == "active") {
            // If looping product and selection product same
            if (products[p].id == pdt.id) {
                if (add_current_pdt) {
                    if (sp == 0) {
                        cartUrl = cartUrl + selected_pdt[pdt.id];
                    }
                    else {
                        cartUrl = cartUrl + '&id[]=' + selected_pdt[pdt.id];
                    }
                    sp = sp + 1;
                }
            }
            else {

                // Loop through variants of looping product and find matched variant from selected product-variant mapping object
                for (var pv = 0; pv < product_variants.length; pv++) {
                    if (selected_pdt[products[p].id] == product_variants[pv].id) {
                        var variant_select = product_variants[pv].id;
                        if(variant_select.inventory_policy == "deny"){
                            if(variant_select.inventory_quantity<1){
                            if(variant_select.inventory_management==null){
                                if (sp == 0) {
                                cartUrl = cartUrl + product_variants[pv].id;
                                }
                                else {
                                    cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                                }
                                sp = sp + 1;
                            } 
                            }
                            else{
                                if (sp == 0) {
                                cartUrl = cartUrl + product_variants[pv].id;
                                }
                                else {
                                    cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                                }
                                sp = sp + 1;
                            }
                        }
                        else{
                            if (sp == 0) {
                                cartUrl = cartUrl + product_variants[pv].id;
                            }
                            else {
                                cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                            }
                            sp = sp + 1;
                        }
                    }
                }
            }
        }
        variant_product_url = domainUrl + '/products/';
        // To Set Variant Price dynamically 
        if (products[p].id == pdt.id) {
            var variant_pdt_matched = false;
            for (var pv = 0; pv < product_variants.length; pv++) {
                if (selected_pdt[products[p].id] == product_variants[pv].id) {
                    variant_pdt_matched = true;
                    variant_price = variant_price + product_variants[pv].price;
                    variant_product_url = variant_product_url + pdt.handle + "?variant=" + product_variants[pv].id;
                    
                    variant_image = getVariantImage(product_variants[pv].image_id, products[p]);
                }
            }
            if (!variant_pdt_matched) {
                variant_price = variant_price + product_variants[0].price;
                variant_product_url = variant_product_url + pdt.handle + "?variant=" + product_variants[0].id;
            }
            document.getElementById("url_tangent_product_" + pId).href = variant_product_url;
        }
    }
    document.getElementById("price_tangent_product_" + pId).innerHTML = variant_price;

    // Change of image based on variant
    if(variant_image!=undefined){
        document.getElementById("image_tangent_product_" + pId).src = variant_image;
    }

    addToCartCount = sp;
    addAllToCartLink = cartUrl;
}

const isSelectedVariantPresent = (selectedVariants, productId) => {
    for (let key in selectedVariants) {
        if (key == productId) {
            if (selectedVariants[key] == null) {
                return [];
            }
            else if (typeof selectedVariants[key] == "string") {
                return selectedVariants[key].split();
            }
            else {
                return selectedVariants[key];
            }
        }
    }
}

const getVariantImage = (imageId, product) => {
    var pdtImg;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    pdtImg = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            pdtImg = product.image.src;
        }
        else{
            pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(pdtImg== undefined || pdtImg==null){
        pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return pdtImg;
}

function addToCart(pid, eId){ 
    var data = {
        "id": pid,
        "quantity": 1
    };
      
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
            var elemID = "cart_tangent_product_"+eId+"_text";
            var element = document.getElementById(elemID)
            element.innerHTML = "Added to Cart!";
            element.classList.add("added-to-cart-style");
          
            document.documentElement.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            })); 
        }, 
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log("Error on adding to cart",textStatus);
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    });
    
}

// Show / Hide loader
function toggle_loader_view(fg){
  if(fg){
    document.getElementById("tangent-selfie-loader").setAttribute("style","display:flex;text-align:center;padding:0px 10px;width:300px;margin:4%");
  }
  else{
    document.getElementById("tangent-selfie-loader").setAttribute("style","display:none");
  }
}

function changeLoadingText(txt){
    document.getElementById("loading_text").innerHTML = txt;
}

// Default message Popup
function show_selfie_popupmessage(message){
  document.getElementById("tangent-popup-msg").innerHTML += message;
  const element = el("#tangent_selfie_div");
  var rect = element.getBoundingClientRect();
  document.getElementById("tangent-popup-msg").setAttribute("style","top:10px;left:"+element.offsetLeft+";display:block;max-width: 400px; border:1px solid #cccccc");
}

function getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
}

// Check for product from product list and make popup message on image
function checkForProduct(){
  var add_to_list = 0;
  for(var fr=0;fr<final_selected_regions.length;fr++){
    var c_area;
    var html_msg;
    if(final_selected_regions[fr].includes("acne")){
      c_area = final_selected_regions[fr].replace('acne_','');
      html_msg= '<p>Our AI detected acne here.</p>';
    } 
    else if(final_selected_regions[fr].includes("wrinkles")){
      c_area = final_selected_regions[fr].replace('wrinkles_','');
      html_msg= '<p>Our AI detected signs of fine lines or wrinkles here.</p>';  
    } 
    else if(final_selected_regions[fr].includes("rosacea")){
      c_area = final_selected_regions[fr].replace('rosacea_','');
      html_msg= '<p>Redness can be due to a sensitive skin.</p>';
    } 
    else if(final_selected_regions[fr].includes("dark_spots")){
      c_area = final_selected_regions[fr].replace('dark_spots_','');
      html_msg= '<p>Dark spots or blemishes can be managed by proper care.</p>';    
    }
    else if(final_selected_regions[fr].includes("dark_circles")){
      c_area = final_selected_regions[fr].replace('dark_circles_','');
      html_msg= '<p>Dark circles are commonly caused by lack of sleep or dehydration.</p>';
    } 
    else{
      
    }
    if(add_to_list<5){
       var cm_map = {
        area:c_area,
        msg: html_msg
      };
      add_to_list = add_to_list+1;
      condition_msg_map.push(cm_map);
    }
  }  
}

function getProductUsingId(id){
  if(products.length>0){
    for(var p=0;p<products.length;p++){
    
      if(products[p].id==id){
        return products[p];
      }
    }
  }
  return null;
}

class TangentSelfie {

	//static MODEL_URL = 'https://cdn.shopify.com/s/files/1/0874/6120/t/175/assets/';
	
	areasToMarkArray = []

  FILL_COLOR = 'rgba(255, 255, 255, 0.2)'
	STROKE_COLOR = 'rgba(255, 255, 255, 0.6)'
	STROKE_HIGHLIGHT_COLOR = 'rgba(255, 255, 255, 1)'
	
	UNDER_EYE_BAGS_HEIGHT = 15
	CHIN_AREA_HEIGHT = 20
	MOUTH_WRINKLES_WIDTH = 10

	EYE_WRINKLE_MIN_WIDTH = 10
	EYE_WRINKLE_MAX_WIDTH = 15
	CHEEK_WIDTH_CUTOFF = 30
	UNDER_EYE_BAGS_WIDTH_CUTTOFF = 20

  CHEEK_MAX_WIDTH = 35
  CHEEK_MAX_HEIGHT = 35

  FOREHEAD_MAX_WIDTH = 55
  FOREHEAD_MAX_HEIGHT = 30

	constructor(imgId){
		this.img = document.getElementById(imgId);
	}

	async init(assetsBaseUrl) {
      try{
        // Handle the case if the image is not loaded yet
        await this.imageLoad(this.img);
        await this.sleep(2000); // To allow canvas to resize
        console.log("running");
        const options = new faceapi.SsdMobilenetv1Options({ minConfidence: 0.2 })
        await faceapi.loadSsdMobilenetv1Model(assetsBaseUrl);
        await faceapi.loadFaceLandmarkModel(assetsBaseUrl);

        this.faceLandmarks = await faceapi.detectSingleFace(this.img, options).withFaceLandmarks();
        this.detection = this.faceLandmarks.detection;

      } catch(e){
        console.log(e);
      }

      if(!this.detection){
        throw new Error("Detection was not found");
      }
	}

	async imageLoad(imgElem) {
	    return new Promise(res => {
	        if (imgElem.complete) {
	            return res();
	        }
	        imgElem.onload = () => res();
	        imgElem.onerror = () => res();
	    });
	}

	async sleep(ms) {
	    return new Promise(resolve => setTimeout(resolve, ms));
	}

	get imgWidth(){
		return this.detection.imageWidth
	}

	get imgHeight(){
		return this.detection.imageHeight
	}

	/* ------------------ Facial feature mathematical functions ---------------------- */

	getAngleToFaceRightInRadians(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()

		const theta = this.getAngleWithXAxisInRadians(leftEyePoints[0], rightEyePoints[0])
		if(theta < Math.PI/2){
			return theta // Face tilted to clockwise
		} else {
			return theta - Math.PI // Face tilted to anti-clockwise
		}
	}

	getAngleToFaceLeftInRadians(){
		return this.getAngleToFaceRightInRadians() - Math.PI
	}

	getAngleToFaceDownInRadians(){
		let horzontalAngle = this.getAngleToFaceRightInRadians()
		return horzontalAngle + Math.PI/2
	}

	getAngleToFaceUpInRadians(){
		return this.getAngleToFaceDownInRadians() - Math.PI
	}

	getLeftEyeHeight(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		const h1 = this.getDistanceBetweenPoints(leftEyePoints[1], leftEyePoints[5])
		const h2 = this.getDistanceBetweenPoints(leftEyePoints[2], leftEyePoints[4])
		return Math.max(h1, h2)
	}

	getLeftEyeWidth(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		return this.getDistanceBetweenPoints(leftEyePoints[0], leftEyePoints[3])
	}

	getRightEyeHeight(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		const h1 = this.getDistanceBetweenPoints(rightEyePoints[1], rightEyePoints[5])
		const h2 = this.getDistanceBetweenPoints(rightEyePoints[2], rightEyePoints[4])
		return Math.max(h1, h2)
	}

	getLeftCrowFeetHeight(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow()
		return this.getDistanceBetweenPoints(leftEyePoints[0], leftEyeBrowPoints[1])
	}

	getRightCrowFeetHeight(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		let rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow()
		return this.getDistanceBetweenPoints(rightEyePoints[3], rightEyeBrowPoints[3])
	}

	getRightEyeWidth(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		return this.getDistanceBetweenPoints(rightEyePoints[0], rightEyePoints[3])
	}

	getLeftCrowFeetWidth(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		return Math.min(this.EYE_WRINKLE_MAX_WIDTH, this.getDistanceBetweenPoints(leftEyePoints[0], jawOutlinePoints[0]))
	}

	getRightCrowFeetWidth(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		return Math.min(this.EYE_WRINKLE_MAX_WIDTH, this.getDistanceBetweenPoints(rightEyePoints[3], jawOutlinePoints[16]))
	}

	getNoseWidth(){
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		return this.getDistanceBetweenPoints(nosePoints[4], nosePoints[8])
	}

	getNoseHeight(){
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		return this.getDistanceBetweenPoints(nosePoints[0], nosePoints[6])
	}

	getMouthWidth(){
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		return this.getDistanceBetweenPoints(mouthPoints[0], mouthPoints[6])
	}

	getMouthHeight(){
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		return this.getDistanceBetweenPoints(mouthPoints[3], mouthPoints[9])
	}

	getForeheadWidth(){
		let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow()
		let rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow()
		return this.getDistanceBetweenPoints(leftEyeBrowPoints[2], rightEyeBrowPoints[2])
	}

	getForeheadHeight(){
		let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow()
		let rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow()

		let faceTopPt = this.getToptMostPt(this.getFaceBounds())

		const h1 = leftEyeBrowPoints[2]._y - faceTopPt._y
		const h2 = rightEyeBrowPoints[2]._y - faceTopPt._y 

		return Math.min(h1, h2)
	}

	getLeftCheekWidth(){
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		return this.getDistanceBetweenPoints(jawOutlinePoints[3], nosePoints[4])
	}

	getRightCheekWidth(){
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		return this.getDistanceBetweenPoints(jawOutlinePoints[13], nosePoints[8])
	}

	getCheekHeight(){
		return this.getNoseHeight() - this.UNDER_EYE_BAGS_HEIGHT
	}

	getChinWidth(){
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		return this.getDistanceBetweenPoints(jawOutlinePoints[7], jawOutlinePoints[9])
	}

	getChinHeight(){
		/*let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		return this.getDistanceBetweenPoints(jawOutlinePoints[8], mouthPoints[9])*/
		return this.CHIN_AREA_HEIGHT
	}

	getFaceBounds(){
		const leftX = this.detection._box._x
		const rightX = this.detection._box._x + this.detection._box._width
		const topY = this.detection._box._y
		const bottomY = this.detection._box._y + this.detection._box._height
		return [{_x: leftX, _y: topY}, {_x: rightX, _y: bottomY}]
	}

	getForeheadBounds() {
    let foreheadWidth = this.getForeheadWidth()
    let foreheadLeftRightPadding = 0
    if(foreheadWidth > this.FOREHEAD_MAX_WIDTH){
      foreheadLeftRightPadding = (foreheadWidth - this.FOREHEAD_MAX_WIDTH)/2
      foreheadWidth = this.FOREHEAD_MAX_WIDTH
    }

    let foreheadHeight = this.getForeheadHeight()
    let foreheadTopBottomPadding = 0
    if(foreheadHeight > this.FOREHEAD_MAX_HEIGHT){
      foreheadTopBottomPadding = (foreheadHeight - this.FOREHEAD_MAX_HEIGHT)/2
      foreheadHeight = this.FOREHEAD_MAX_HEIGHT
    }

    let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow()


    const leftBrowPt = leftEyeBrowPoints[2]
    const leftPaddingPt = this.getPointAtDistanceAndAngle(leftBrowPt, foreheadLeftRightPadding, this.getAngleToFaceRightInRadians())

    const leftBottomPt = this.getPointAtDistanceAndAngle(leftPaddingPt, foreheadTopBottomPadding, this.getAngleToFaceUpInRadians())

    const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, foreheadWidth, this.getAngleToFaceRightInRadians())
    const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, foreheadHeight, this.getAngleToFaceUpInRadians())
    const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, foreheadHeight, this.getAngleToFaceUpInRadians())

    return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
  }

	getLeftUnderEyeBounds() {
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		
		const leftTopPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftEyeHeight()/2, this.getAngleToFaceDownInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getLeftEyeWidth(), this.getAngleToFaceRightInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(leftTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians())
		const rightBottomPt = this.getPointAtDistanceAndAngle(rightTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians())

		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getRightUnderEyeBounds() {
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		
		const leftTopPt = this.getPointAtDistanceAndAngle(rightEyePoints[0], this.getRightEyeHeight()/2, this.getAngleToFaceDownInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getRightEyeWidth(), this.getAngleToFaceRightInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(leftTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians())
		const rightBottomPt = this.getPointAtDistanceAndAngle(rightTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getLeftCrowFeetBounds(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		
		const rightBottomPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftCrowFeetHeight()/2, this.getAngleToFaceDownInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftCrowFeetHeight()/2, this.getAngleToFaceUpInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getLeftCrowFeetWidth(), this.getAngleToFaceLeftInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(rightTopPt, this.getLeftCrowFeetWidth(), this.getAngleToFaceLeftInRadians())

		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getRightCrowFeetBounds(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		
		const leftTopPt = this.getPointAtDistanceAndAngle(rightEyePoints[3], this.getRightCrowFeetHeight()/2, this.getAngleToFaceUpInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(rightEyePoints[3], this.getRightCrowFeetHeight()/2, this.getAngleToFaceDownInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getRightCrowFeetWidth(), this.getAngleToFaceRightInRadians())
		const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getRightCrowFeetWidth(), this.getAngleToFaceRightInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getNoseBounds(){
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		
		const leftBottomPt = nosePoints[4]
		const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getNoseWidth(), this.getAngleToFaceRightInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getNoseHeight(), this.getAngleToFaceUpInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getNoseHeight(), this.getAngleToFaceUpInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getLeftCheekBounds(){
    let cheekWidth = this.getLeftCheekWidth()
    let cheekLeftRightPadding = 0
    if(cheekWidth > this.CHEEK_MAX_WIDTH){
      cheekLeftRightPadding = (cheekWidth - this.CHEEK_MAX_WIDTH)/2
      cheekWidth = this.CHEEK_MAX_WIDTH
    }

    let cheekHeight = this.getCheekHeight()
    let cheekTopBottomPadding = 0
    if(cheekHeight > this.CHEEK_MAX_HEIGHT){
      cheekTopBottomPadding = (cheekHeight - this.CHEEK_MAX_HEIGHT)/2
      cheekHeight = this.CHEEK_MAX_HEIGHT
    }

    const leftJawPt = this.faceLandmarks.landmarks.getJawOutline()[3] 
    const leftPaddingPt = this.getPointAtDistanceAndAngle(leftJawPt, cheekLeftRightPadding, this.getAngleToFaceRightInRadians())

    const leftBottomPt = this.getPointAtDistanceAndAngle(leftPaddingPt, cheekTopBottomPadding, this.getAngleToFaceUpInRadians())

    const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekWidth, this.getAngleToFaceRightInRadians())
    const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekHeight, this.getAngleToFaceUpInRadians())
    const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekHeight, this.getAngleToFaceUpInRadians())
    
    return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
  }

  getRightCheekBounds(){
    let cheekWidth = this.getRightCheekWidth()
    let cheekLeftRightPadding = 0
    if(cheekWidth > this.CHEEK_MAX_WIDTH){
      cheekLeftRightPadding = (cheekWidth - this.CHEEK_MAX_WIDTH)/2
      cheekWidth = this.CHEEK_MAX_WIDTH
    }

    let cheekHeight = this.getCheekHeight()
    let cheekTopBottomPadding = 0
    if(cheekHeight > this.CHEEK_MAX_HEIGHT){
      cheekTopBottomPadding = (cheekHeight - this.CHEEK_MAX_HEIGHT)/2
      cheekHeight = this.CHEEK_MAX_HEIGHT
    }

    const rightJawPt = this.faceLandmarks.landmarks.getJawOutline()[13] 
    const rightPaddingPt = this.getPointAtDistanceAndAngle(rightJawPt, cheekLeftRightPadding, this.getAngleToFaceLeftInRadians())

    const rightBottomPt = this.getPointAtDistanceAndAngle(rightPaddingPt, cheekTopBottomPadding, this.getAngleToFaceUpInRadians())

    const leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekWidth, this.getAngleToFaceLeftInRadians())
    const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekHeight, this.getAngleToFaceUpInRadians())
    const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekHeight, this.getAngleToFaceUpInRadians())
    
    return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
  }

	getChinBounds(){
		const leftBottomPt = this.faceLandmarks.landmarks.getJawOutline()[7] 

		const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getChinWidth(), this.getAngleToFaceRightInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getChinHeight(), this.getAngleToFaceUpInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getChinHeight(), this.getAngleToFaceUpInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getLeftMouthWrinkleBounds(){
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		
		const rightBottomPt = this.getPointAtDistanceAndAngle(mouthPoints[0], this.getMouthHeight()/2, this.getAngleToFaceDownInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.MOUTH_WRINKLES_WIDTH, this.getAngleToFaceLeftInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getRightMouthWrinkleBounds(){
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		
		const leftBottomPt = this.getPointAtDistanceAndAngle(mouthPoints[6], this.getMouthHeight()/2, this.getAngleToFaceDownInRadians())
		const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.MOUTH_WRINKLES_WIDTH, this.getAngleToFaceRightInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	/* ------------------ Utility methods ---------------------- */

	getDistanceBetweenPoints(p1, p2) {
		return Math.sqrt(Math.pow(p1._x - p2._x, 2) + Math.pow(p1._y - p2._y, 2))
	}

	getMidpointBetweenPoints(p1, p2) {
		return {_x: Math.abs((p1._x + p2._x)/2), _y: Math.abs((p1._y + p2._y)/2)}
	}

	getAngleWithXAxisInRadians(p1, p2) {
		let dy = p1._y - p2._y;
		let dx = p1._x - p2._x;
		let theta = Math.atan2(dy, dx); // range (-PI, PI]
		if (theta < 0) {
			theta += Math.PI
		} 
		// let degrees = (theta * 180) / Math.PI;
		// console.log(degrees);
		return theta;
	}

	getPointAtDistanceAndAngle(sourcePt, distance, angle) {
		// p2(x) = p1(x) + dCosQ
		// p2(y) = p1(y) + dSinQ
		return {_x: sourcePt._x + distance*Math.cos(angle), _y:sourcePt._y + distance*Math.sin(angle)}
	}

	getLeftMostPt(pointsArray) {
		let leftMost = null
		for (let i = 0; i < pointsArray.length; i++) {
			if(leftMost == null || pointsArray[i]._x < leftMost._x){
				leftMost = pointsArray[i];
			}			  
		}
		return leftMost;
	}

	getRightMostPt(pointsArray) {
		let rightMost = null
		for (let i = 0; i < pointsArray.length; i++) {
			if(rightMost == null || pointsArray[i]._x > rightMost._x){
				rightMost = pointsArray[i];
			}			  
		}
		return rightMost;
	}

	getToptMostPt(pointsArray) {
		let topMost = null
		for (let i = 0; i < pointsArray.length; i++) {
			if(topMost == null || pointsArray[i]._y < topMost._y){
				topMost = pointsArray[i];
			}			  
		}
		return topMost;
	}

	isPointInsidePoligon(pt, points) {
	    // https://stackoverflow.com/a/29915728/960654
	    // ray-casting algorithm based on
	    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
	    
	    var x = pt._x, y = pt._y;
	    
	    var inside = false;
	    for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
	        var xi = points[i]._x, yi = points[i]._y;
	        var xj = points[j]._x, yj = points[j]._y;
	        
	        var intersect = ((yi > y) != (yj > y))
	            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
	        if (intersect) inside = !inside;
	    }
	    
	    return inside;
	}

	/* ------------------ Canvas methods ---------------------- */

	clearCanvas(canvas){
		const ctx = canvas.getContext('2d');
		ctx.resetTransform();
		ctx.clearRect(0, 0, canvas.width, canvas.height);
	}

	scaleCanvas(canvas){
		var ctx = canvas.getContext("2d");
		ctx.resetTransform();
		ctx.scale(canvas.width/this.imgWidth, canvas.height/this.imgHeight);
  }

  scaleUpPt(originalPt, canvas){
    const canvasWidth = canvas.getBoundingClientRect().width;
    const canvasHeight = canvas.getBoundingClientRect().height;
    return {_x: (canvasWidth * originalPt._x)/this.imgWidth, _y: (canvasHeight * originalPt._y)/this.imgHeight}
  }

	scaleBackPt(scaledPt, canvas){
		const canvasWidth = canvas.getBoundingClientRect().width;
		const canvasHeight = canvas.getBoundingClientRect().height;
		return {_x: (this.imgWidth * scaledPt._x)/canvasWidth, _y: (this.imgHeight * scaledPt._y)/canvasHeight}
	}

	applyCanvasStrokeColor(canvas, color){
		var ctx = canvas.getContext("2d");
		ctx.strokeStyle = color
	}

	setStrokeColor(color){
		this.STROKE_COLOR = color
	}

	setHighlightStrokeColor(color){
		this.STROKE_HIGHLIGHT_COLOR = color
	}

	setAreaClickCallback(canvas, callback, setFirstAutoClick=false){
		this.areaClickCallback = callback

    if(setFirstAutoClick && this.areasToMarkArray.length > 0) {
      this.areasToMarkArray[0].clicked = true
      this.drawAllShapes(canvas)

      const scaledPt = this.scaleUpPt(this.areasToMarkArray[0].points[0], canvas)
      this.areaClickCallback(this.areasToMarkArray[0].area, this.areasToMarkArray[0].messageOnClick, scaledPt._x, scaledPt._y)
    }
	}

	appendAreaToArray(area, points, messageOnClick){
		this.areasToMarkArray.push({
			area: area,
			points: points,
			messageOnClick: messageOnClick
		})
	}

	markFacialArea(canvas, area, messageOnClick){
		let points = null;
		switch(area) {
			case 'forehead':
				points = this.getForeheadBounds()
				break;
			case 'left_eye_under':
				points = this.getLeftUnderEyeBounds()
				break;
			case 'right_eye_under':
				points = this.getRightUnderEyeBounds()
				break;
			case 'left_eye_corner':
				points = this.getLeftCrowFeetBounds()
				break;
			case 'right_eye_corner':
				points = this.getRightCrowFeetBounds()
				break;
			case 'nose':
				points = this.getNoseBounds()
				break;
			case 'left_cheek':
				points = this.getLeftCheekBounds()
				break;
			case 'right_cheek':
				points = this.getRightCheekBounds()
				break;
			case 'left_lip_corner':
				points = this.getLeftMouthWrinkleBounds()
				break;
			case 'right_lip_corner':
				points = this.getRightMouthWrinkleBounds()
				break;
			case 'chin':
				points = this.getChinBounds()
				break;
		}

		if(points != null){
			this.appendAreaToArray(area, points, messageOnClick)
			this.drawAllShapes(canvas)
		}
	}

	drawAllShapes(canvas){
		this.clearCanvas(canvas)
		this.applyCanvasStrokeColor(canvas, this.STROKE_COLOR)
		for (let i = 0; i < this.areasToMarkArray.length; i++) {
			this.drawSingleShape(canvas, this.areasToMarkArray[i].area, this.areasToMarkArray[i].points, 'clicked' in this.areasToMarkArray[i])
		}

		if(this.clickListener){
			canvas.removeEventListener("click", this.clickListener, true);
		}
		this.clickListener = this.canvasClickListener.bind(this)
		canvas.addEventListener("click", this.clickListener, true);
	}

	drawSingleShape(canvas, area, points, clicked){
    switch(area) {
      case 'forehead':
        this.drawForehead(canvas, area, points, clicked)
        break;
      case 'left_eye_under':
        this.drawUnderEyeBags(canvas, area, points, clicked)
        break;
      case 'right_eye_under':
        this.drawUnderEyeBags(canvas, area, points, clicked)
        break;
      case 'left_eye_corner':
        this.drawEyeWrinkles(canvas, area, points, clicked)
        break;
      case 'right_eye_corner':
        this.drawEyeWrinkles(canvas, area, points, clicked)
        break;
      case 'nose':
        this.drawNose(canvas, area, points, clicked)
        break;
      case 'left_cheek':
        this.drawCheeks(canvas, area, points, clicked)
        break;
      case 'right_cheek':
        this.drawCheeks(canvas, area, points, clicked)
        break;
      case 'left_lip_corner':
        this.drawMouthWrinkles(canvas, area, points, clicked)
        break;
      case 'right_lip_corner':
        this.drawMouthWrinkles(canvas, area, points, clicked)
        break;
      case 'chin':
        this.drawChin(canvas, area, points, clicked)
        break;
    }
  }

	getCursorPosition(canvas, event) {
	    const rect = canvas.getBoundingClientRect()
	    const x = event.clientX - rect.left
	    const y = event.clientY - rect.top
	    // console.log("x: " + x + " y: " + y)
	    return {_x: x, _y: y}
	}

	canvasClickListener(event){
    let canvas = event.target || event.srcElement;
    const clickPt = this.getCursorPosition(canvas, event)

    let shapeClickedIndex = -1

    for (let i = 0; i < this.areasToMarkArray.length; i++) {
      if(shapeClickedIndex == -1 && this.isPointInsidePoligon(this.scaleBackPt(clickPt, canvas), this.areasToMarkArray[i].points)){
        shapeClickedIndex = i
        this.areasToMarkArray[i].clicked = true
      } else if('clicked' in this.areasToMarkArray[i]){
        delete this.areasToMarkArray[i].clicked
      }
    }

    this.drawAllShapes(canvas) 

    if(this.areaClickCallback){
      // Call the callback function if it is outside any shape with null area value
      if(shapeClickedIndex == -1){
        this.areaClickCallback(null, null, clickPt._x, clickPt._y)
      } else {
        this.areaClickCallback(this.areasToMarkArray[shapeClickedIndex].area, this.areasToMarkArray[shapeClickedIndex].messageOnClick, clickPt._x, clickPt._y)
      }
    }
  }

  drawForehead(canvas, area, points, clicked) {
    this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
  }

  drawUnderEyeBags(canvas, area, points, clicked) {
    if(area == 'left_eye_under' && this.getLeftEyeWidth() > this.UNDER_EYE_BAGS_WIDTH_CUTTOFF){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }

    if(area == 'right_eye_under' && this.getRightEyeWidth() > this.UNDER_EYE_BAGS_WIDTH_CUTTOFF){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
  }

  drawNose(canvas, area, points, clicked) {
    this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
  }

  drawCheeks(canvas, area, points, clicked) {
    if(area == 'left_cheek' && this.getLeftCheekWidth() > this.CHEEK_WIDTH_CUTOFF){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }

    if(area == 'right_cheek' && this.getRightCheekWidth() > this.CHEEK_WIDTH_CUTOFF){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
  }
  
  drawChin(canvas, area, points, clicked) {
    this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
  }

  drawMouthWrinkles(canvas, area, points, clicked) {
    if(area == 'left_lip_corner'){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    if(area == 'right_lip_corner'){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
  }

  drawEyeWrinkles(canvas, area, points, clicked) {
    if(area == 'left_eye_corner' && this.getLeftCrowFeetWidth() > this.EYE_WRINKLE_MIN_WIDTH){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }

    if(area == 'right_eye_corner' && this.getRightCrowFeetWidth() > this.EYE_WRINKLE_MIN_WIDTH){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
  }

	drawDetections(canvas){
		this.scaleCanvas(canvas)
		faceapi.draw.drawDetections(canvas, this.detection);
	}

	drawLandmarks(canvas){
		this.scaleCanvas(canvas)
		faceapi.draw.drawFaceLandmarks(canvas, this.faceLandmarks);
	}

	drawPolygonOnCanvas(canvas, points){
		this.scaleCanvas(canvas)

		var ctx = canvas.getContext("2d");
		for (let i = 0; i < points.length-1; i++) {
			ctx.beginPath();
			ctx.moveTo(points[i]._x, points[i]._y);
			ctx.lineTo(points[i+1]._x, points[i+1]._y);
			ctx.stroke();
		}

		// Final closing the polygon
		ctx.beginPath();
		ctx.moveTo(points[points.length-1]._x, points[points.length-1]._y);
		ctx.lineTo(points[0]._x, points[0]._y);
		ctx.stroke();
	}

	drawRectangleOnCanvas(canvas, rectanglePoints){
		this.scaleCanvas(canvas)

		var ctx = canvas.getContext("2d");
		ctx.beginPath();
		// ctx.rect(x, y, width, height);
		ctx.rect(rectanglePoints[0]._x, rectanglePoints[0]._y, rectanglePoints[1]._x - rectanglePoints[0]._x, rectanglePoints[1]._y - rectanglePoints[0]._y);
		ctx.stroke();
	}

	drawEllipseOnCanvas(canvas, rectanglePoints, tiltInRadians=0, clicked){
    this.scaleCanvas(canvas)

    let p1 = rectanglePoints[0]
    let p2 = rectanglePoints[1]
    let p3 = rectanglePoints[2]
    let p4 = rectanglePoints[3]

    let d1 = this.getDistanceBetweenPoints(p1, p2)/2
    let d2 = this.getDistanceBetweenPoints(p1, p4)/2
    let m = this.getMidpointBetweenPoints(p1, p3)

    var ctx = canvas.getContext("2d");
    ctx.beginPath();
    // ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle)
    ctx.ellipse(m._x, m._y, d2, d1, tiltInRadians, 0, Math.PI*2);

    if(clicked){
      ctx.strokeStyle = this.STROKE_HIGHLIGHT_COLOR;
    } else {
      ctx.strokeStyle = this.STROKE_COLOR;
    }

    ctx.fillStyle = this.FILL_COLOR;
    ctx.fill();
    ctx.stroke();
  }
}

function selfieAreaClicked(area, message, x, y){
  document.getElementById("tangent-popup-msg-condition").innerHTML = message;
  if(area!=null){
    // const element = el("#tangent_selfie_div");
    // Object.assign(elPopupCondtion.style, {top: '10px', left: element.offsetLeft,display:'block',maxWidth: '400px', border: '1px solid #cccccc'});
     Object.assign(elPopupCondtion.style, {
        left: (x-30)+'px',
        top: (y+45)+'px',
        display: 'block',
    });
  }
  else{
    Object.assign(elPopupCondtion.style, {
        display: `none`,
    });
  }
}

//TO CLOSE POPUP IF OPEN ALREADY
document.body.addEventListener("click", function (evt) {
    if(evt.target.id != "selfie_canvas") {
      canvas.dispatchEvent(new MouseEvent("click", {
        clientX: 0,
        clientY: 0
      }));
    }
    if(evt.target.id == "popup-close-btn"){
      document.getElementById("tangent-popup-msg").style.display="none";
    }
});

const canvas = document.getElementById('selfie_canvas');
let selfie = new TangentSelfie('selfie_img');

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});